<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="rows"
          multiTemplateDataRows
          class="mat-mdc-table mdc-data-table__table cdk-table table text-nowrap text-md-nowrap table-bordered technical-table"
        >
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef class="expand-header">-</th>
            <td mat-cell *matCellDef="let row" class="expand-cell">
              <button
                mat-icon-button
                type="button"
                class="expand-btn"
                (click)="toggle(row); $event.stopPropagation()"
                [attr.aria-label]="'Expandir linha'"
              >
                <mat-icon class="expand-icon">
                  {{ isExpanded(row) ? "expand_less" : "expand_more" }}
                </mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="cnpj">
            <th mat-header-cell *matHeaderCellDef>
              <span style="text-transform: none">{{ "CNPJ" | titlecase }}</span>
            </th>
            <td mat-cell *matCellDef="let row">
              {{
                row?.company?.cnpj || row?.id
                  ? (row?.company?.cnpj || row?.id | mask: "CPF_CNPJ")
                  : "-"
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="empresa">
            <th mat-header-cell *matHeaderCellDef>
              <span style="text-transform: none">{{
                "Empresa" | titlecase
              }}</span>
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row?.company?.razaoSocial | titlecase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>
              <span style="text-transform: none">{{
                "Email" | titlecase
              }}</span>
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row?.company?.email || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="responsavel">
            <th mat-header-cell *matHeaderCellDef>
              <span style="text-transform: none">{{
                "Responsável" | titlecase
              }}</span>
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row?.sponsor?.name | titlecase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="endereco">
            <th mat-header-cell *matHeaderCellDef>
              <span style="text-transform: none">{{
                "Endereço" | titlecase
              }}</span>
            </th>
            <td mat-cell *matCellDef="let row">
              {{ enderecoLabel(row) | titlecase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let row"
              [attr.colspan]="displayedColumnsWithExpand.length"
              class="expanded-detail-cell"
            >
              <div
                class="expanded-detail"
                [@detailExpand]="isExpanded(row) ? 'expanded' : 'collapsed'"
              >
                <div class="detail-box">
                  <div
                    class="detail-loading"
                    *ngIf="detailsLoading[rowCnpj(row)]"
                  >
                    <div class="dimmer active">
                      <div class="lds-ring"><div></div></div>
                    </div>
                  </div>

                  <div
                    class="table-responsive"
                    *ngIf="!detailsLoading[rowCnpj(row)]"
                  >
                    <table
                      class="table text-nowrap text-md-nowrap table-bordered inner-table"
                    >
                      <colgroup>
                        <col class="col-project" />
                        <col class="col-site" />
                        <col class="col-compact" />
                        <col class="col-compact" />
                        <col class="col-actions" />
                      </colgroup>

                      <thead>
                        <tr>
                          <th>
                            <span style="text-transform: none">{{
                              "Nome Projeto" | titlecase
                            }}</span>
                          </th>
                          <th>
                            <span style="text-transform: none">{{
                              "Site" | titlecase
                            }}</span>
                          </th>
                          <th>
                            <span style="text-transform: none">{{
                              "Licenciamento" | titlecase
                            }}</span>
                          </th>
                          <th>
                            <span style="text-transform: none">{{
                              "Banco" | titlecase
                            }}</span>
                          </th>
                          <th class="inner-actions">
                            <span style="text-transform: none">{{
                              "Ações" | titlecase
                            }}</span>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let item of details[rowCnpj(row)] || []">
                          <td [title]="reg(item)?.nameProject || '-'">
                            <span class="cell-ellipsis">
                              {{ reg(item)?.nameProject | titlecase }}
                            </span>
                          </td>

                          <td [title]="reg(item)?.site || '-'">
                            <a
                              *ngIf="reg(item)?.site"
                              [href]="reg(item)?.site"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="site-link"
                            >
                              {{ reg(item)?.site }}
                            </a>
                            <span *ngIf="!reg(item)?.site">-</span>
                          </td>

                          <td
                            [title]="
                              licensingLabel(reg(item)?.licensingRegistrationId)
                            "
                          >
                            <span class="cell-ellipsis">
                              {{
                                licensingLabel(reg(item)?.licensingRegistrationId)
                                  | titlecase
                              }}
                            </span>
                          </td>

                          <td
                            class="bank-cell"
                            [title]="reg(item)?.bankProvider || '-'"
                          >
                            <span class="cell-ellipsis bank-text">
                              {{ reg(item)?.bankProvider || "-" }}
                            </span>
                          </td>

                          <td class="inner-actions">
                            <button
                              type="button"
                              class="btn text-primary btn-sm"
                              (click)="innerEdit(item, $event)"
                              placement="top"
                              ngbTooltip="Editar"
                            >
                              <i class="fe fe-edit-2 fs-14 btn-color"></i>
                            </button>

                            <button
                              type="button"
                              class="btn text-primary btn-sm"
                              (click)="innerView(item, $event)"
                              placement="top"
                              ngbTooltip="Visualizar"
                            >
                              <i class="fe fe-eye fs-14 btn-color"></i>
                            </button>
                          </td>
                        </tr>

                        <tr *ngIf="(details[rowCnpj(row)] || []).length === 0">
                          <td colspan="5">
                            <span style="text-transform: none">{{
                              "Não contém dados" | titlecase
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <thead role="rowgroup">
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumnsWithExpand"
              class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row"
            ></tr>
          </thead>

          <tbody role="rowgroup" class="mdc-data-table__content">
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: displayedColumnsWithExpand;
                trackBy: trackById
              "
              class="mat-mdc-row mdc-data-table__row cdk-row clickable-row"
              [class.row-expanded]="isExpanded(row)"
              (click)="toggle(row)"
            ></tr>

            <tr
              mat-row
              *matRowDef="let row; columns: ['expandedDetail']"
              class="detail-row mat-mdc-row mdc-data-table__row cdk-row"
              [class.detail-open]="isExpanded(row)"
            ></tr>

            <tr class="border-bottom" *matNoDataRow>
              <td [attr.colspan]="displayedColumnsWithExpand.length">
                {{ "common.noData" | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</form>
